<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("orders") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <div class="col-lg-6 col-5 text-right">
                    <base-button
                        size="md"
                        type="neutral"
                        @click="handleCreate()"
                        >{{ $t("new") }}</base-button
                    >
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card
                    class="no-border-card"
                    body-classes="px-0 pb-1"
                    footer-classes="pb-2"
                >
                    <template slot="header">
						<div class="row" v-if="params.bo_packing_id != ''">
							<div class="col-md-12">
								{{  $t('packing_number') }} : {{ params.bo_packing_id}}
							</div>
						</div>


                        <div class="row" v-else>
                                <base-input v-if="isSearchAdvance" class="col-md-2 col-xs-12">
                                    <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="{ allowInput: true }"
                                        :placeholder="$t('time_from')"
                                        class="form-control datepicker"
                                        v-model="params.time_from"
                                    >
                                    </flat-picker>
                                </base-input>

                            <div class="col-md-2 col-xs-12">
                                <base-input>
                                    <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="{ allowInput: true }"
                                        :placeholder="$t('time_to')"
                                        class="form-control datepicker"
                                        v-model="params.time_to"
                                    >
                                    </flat-picker>
                                </base-input>
                            </div>

                            <div class="col-lg-3">
                                <base-input
								:label="keywordType"
                                    v-model="params.order_number"
                                    placeholder="หมายเลขสั่งซื้อ, เบอร์โทร, ชื่อ, Tracking"
									v-on:keyup.enter="handleSearch"
                                >
                                </base-input>
                            </div>

                            <div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="params.bo_user_id"
                                        :placeholder="$t('menu.user')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in OptionUserTable"
                                            :key="option.UserID"
                                            :label="option.fname + ' ' + option.lname"
                                            :value="option.UserID"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

                            <!-- <div class="col-md-2" v-if="isSearchAdvance">
                                <base-input>
                                    <el-select
                                        v-model="params.bo_team_id"
                                        :placeholder="$t('menu.team')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in OptionTeamTable"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div> -->

                            <div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="params.order_status"
                                        :placeholder="$t('menu.order_status')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in OrderStatusTable"
                                            :key="option.ID"
                                            :label="option.Name"
                                            :value="option.ID"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

							 <div class="col-md-2" v-if="isSearchAdvance">
                                <base-input>
                                    <el-select
                                        v-model="params.payment_method_type"
                                        :placeholder="$t('payment_method_type')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in PaymentMethodTypeTable"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

							<div class="col-md-2"  v-if="isSearchAdvance">
                                <base-input>
                                    <el-select
                                        v-model="params.bo_sale_channel_id"
                                        :placeholder="$t('sale_channel')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in SaleChannelTableWithAll"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

							<div class="col-md-2"  v-if="isSearchAdvance">
                                <base-input>
                                    <el-select
                                        v-model="params.bo_sale_channel_type_id"
                                        :placeholder="$t('sale_channel_type')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in SaleChannelTypeTableWithAll"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

							<div class="col-md-2"  v-if="isSearchAdvance">
                                <base-input>
                                    <el-select
                                        v-model="params.bo_platform_id"
                                        :placeholder="$t('platform')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in PlatformTable"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

							<div class="col-md-2"  v-if="isSearchAdvance">
                                <base-input>
                                    <el-select
                                        v-model="params.packing_not_close"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in PackingStatusTable"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

							<!-- <div class="col-lg-2">
                                <base-input
                                    v-model="params.recipient_name"
                                    :placeholder="$t('recipient_name')"
									v-on:keyup.enter="handleSearch"
                                >
                                </base-input>
                            </div>

							 <div class="col-lg-2">
                                <base-input
                                    v-model="params.recipient_phone"
                                    :placeholder="$t('recipient_phone')"
									v-on:keyup.enter="handleSearch"
                                >
                                </base-input>
                            </div>

							 <div class="col-lg-2">
                                <base-input
                                    v-model="params.tracking_number"
                                    :placeholder="$t('tracking_number')"
									v-on:keyup.enter="handleSearch"
                                >
                                </base-input>
                            </div> -->

							<div class="col-lg-2" v-if="showForceFilterDate">
								<base-checkbox 
								v-model="params.force_filter_date" class="mb-3">
								ค้นหาโดยใช้วันที่
								</base-checkbox>
							</div>

                            <div class="col-auto">
                                <base-button size="md" @click="handleSearch()">
								<i class="fas fa-spinner fa-spin " v-if="isLoading"></i>
                                    {{ $t("search") }}</base-button
                                >
                                <base-button size="md" @click="searchMode = 'basic'" v-if="isSearchAdvance"> Basic</base-button>
                                <base-button size="md" @click="searchMode = 'advance'" v-if="isSearchBasic"> Advance</base-button>
                                <base-button size="md" :loading="isLoading" @click="handleExport()" v-if="isSearchAdvance"> Export</base-button>
                                <base-button size="md" :loading="isExportLoading" @click="handleExportDetail()" v-if="isSearchAdvance"> Export Detail</base-button>
                            </div>

                        </div>

                    </template>
                    <!-- end header -->

                    <div>
                        <el-table
                            :data="queriedData"
                            row-key="id"
                            header-row-class-name="thead-light"
                        >
                            <!-- order_number -->
                            <el-table-column
                                align="left"
                                :label="$t('order_number')"
                                min-width="80px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.ID }} </span>
                                </div>
                            </el-table-column>

                            <!-- created_at -->
                            <el-table-column
                                align="left"
                                :label="$t('created')"
                                min-width="120px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.created_at }} </span>
                                </div>
                            </el-table-column>

                            <!-- order_platform -->
                            <el-table-column
                                align="left"
                                :label="$t('sale_channel')"
                                min-width="100px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    {{
                                        GetSaleChannelName(
                                            row.bo_sale_channel_id
                                        )
                                    }}
                                </div>
                            </el-table-column>

                            <!-- recipient_name -->
                            <el-table-column
                                align="left"
                                :label="$t('recipient_name')"
                                min-width="150px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.recipient_name }} </span>
                                </div>
                            </el-table-column>

                            <!-- price -->
                            <el-table-column
                                align="left"
                                :label="$t('price')"
                                min-width="100px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.pay_amount }} </span>
                                </div>
                            </el-table-column>

                            <!-- recipient_phone -->
                            <el-table-column
                                align="left"
                                :label="$t('recipient_phone')"
                                min-width="100px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.recipient_phone }} </span>
                                </div>
                            </el-table-column>

                            <!-- bo_order_user -->
                            <el-table-column
                                align="left"
                                :label="$t('order_user')"
                                min-width="100px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.bo_order_user_name }} </span>
                                </div>
                            </el-table-column>

                            <!-- traccking -->
                            <el-table-column
                                align="left"
                                :label="$t('tracking_number')"
                                min-width="100px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span @click="handleCheckTracking(row.shipping_provider_id,row.shipping_tracking_number)"> {{ row.shipping_tracking_number }} </span>
                                </div>
                            </el-table-column>


                            <el-table-column
                                align="left"
                                :label="$t('status')"
                                min-width="150px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <template v-if="row.order_status == 100"> <span class="btn btn-sm"> {{ $t("order_status_unpaid")}} </span> </template>
                                    <template v-if="row.order_status == 111"> <span class="btn btn-info btn-sm"> {{ $t("order_status_awaiting_shipment") }} </span></template>
                                    <template v-if="row.order_status == 112"> <span class="btn btn-info btn-sm"> {{ $t("order_status_awaitingcollection") }} </span></template>
                                    <template v-if="row.order_status == 114"> <span class="btn btn-info btn-sm"> {{ $t("order_status_partiallyshipping") }} </span></template>
                                    <template v-if="row.order_status == 121"> <span class="btn btn-primary btn-sm"> {{ $t("order_status_intransit") }} </span></template>
                                    <template v-if="row.order_status == 122"> <span class="btn btn-primary btn-sm"> {{ $t("order_status_delivered") }} </span></template>
                                    <template v-if="row.order_status == 130"> <span class="btn btn-success btn-sm"> {{ $t("order_status_completed") }} </span></template>
                                    <template v-if="row.order_status == 140"> <span class="btn btn-danger btn-sm"> {{ $t("order_status_cancelled") }} </span></template>
                                    <template v-if="row.order_status == 141"> <span class="btn btn-danger btn-sm"> {{ $t("order_status_returned") }} </span></template>
                                    <template v-if="row.order_status == 142"> <span class="btn btn-danger btn-sm"> {{ $t("order_status_claimed") }} </span></template>
										
                                </div>
                            </el-table-column>

                            <el-table-column
                                align="right"
                                :label="$t('actions')"
                                min-width="120px"
                            >
                                <div
                                    slot-scope="{ $index, row }"
                                    class="d-flex"
                                >
                                    <!-- <base-button
                                        @click.native="
                                            handlePayment($index, row)
                                        "
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-edit"></i>
                                    </base-button> -->
                                    <base-button
                                        @click.native="
                                            handleDetail(row)
                                        "
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-edit"></i>
                                    </base-button>

									<base-button v-if="(row.order_status == 100)"
                                        @click.native="handleChangeShipping(row)"
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fas fa-shipping-fast"></i>
                                    </base-button>

									<base-button v-if="(row.order_status == 130 || row.order_status == 112  || row.order_status == 121) && isAdmin"
                                        @click.native="handleChangeTracking(row)"
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-truck"></i>
                                    </base-button>

                                    <base-button
                                        @click.native=" handleDelete($index, row) "
                                        class="remove btn-link"
                                        type="danger"
                                        size="sm"
                                        icon
										v-if="isAccessDeleleteOrder(row.order_status)"
                                    >
                                        <i class="text-dtac-bt fa fa-trash text-white"></i>
                                    </base-button>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div
                        slot="footer"
                        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        v-if="tableData.length != 0"
                    >
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination
                            class="pagination-no-border"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="total"
                        >
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>


		<modal
            :show.sync="showChangeTrackingModal"
            modal-classes="modal-secondary modal-lg"
        >
            <div class="row">
                <div class="col-md-12">
                    <h5 class="modal-title">
                        แก้ไขหมายเลขพัสดุ - {{ $t("order_number") }} : {{ orderDetail.ID }} - สถานะ
                        : {{ GetOrderStatus(orderDetail.order_status) }}
                    </h5>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <base-input
                        :label="$t('tracking_number')"
                        v-model="tracking"
                    ></base-input>
                </div>
            </div>

			  <template slot="footer">
				<!-- Payment Check Success -->
				<button
                    type="button"
                    class="btn btn-md btn-link ml-auto btn-primary text-white"
                    @click="handleUpdateTracking()"
                >
                    {{ $t("save") }}
                </button>
			  </template>

		</modal>

		<modal
            :show.sync="showChangeShippingModal"
            modal-classes="modal-secondary modal-lg"
        >
            <div class="row">
                <div class="col-md-12">
                    <h5 class="modal-title">
                        แก้ไขช่องทางการจัดส่ง - {{ $t("order_number") }} : {{ orderDetail.ID }} - สถานะ
                        : {{ GetOrderStatus(orderDetail.order_status) }}
                    </h5>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
					 <base-input>
						<el-select
							v-model="shipping_provider_id"
							:placeholder="$t('shipping_provider')"
						>
							<el-option
								v-for="option in ShippingProviderTable"
								:key="option.id"
								:label="option.name"
								:value="option.id"
							>
							</el-option>
						</el-select>
					</base-input>

                </div>
            </div>

			  <template slot="footer">
				<!-- Payment Check Success -->
				<button
                    type="button"
                    class="btn btn-md btn-link ml-auto btn-primary text-white"
                    @click="handleUpdateShipping()"
                >
                    {{ $t("save") }}
                </button>
			  </template>

		</modal>

        <modal
            :show.sync="showDetailModal"
            modal-classes="modal-secondary modal-lg"
        >
            <div class="row">
                <div class="col-md-12">
                    <h5 class="modal-title">
                        {{ $t("order_detail") }} : {{ orderDetail.ID }} - สถานะ
                        : {{ GetOrderStatus(orderDetail.order_status) }}
                    </h5>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <base-input
                        label="ผู้สั่งซื้อ"
                        :value="orderDetail.recipient_name"
                    ></base-input>
                </div>
                <div class="col-md-3">
                    <base-input
                        label="โทรศัพท์"
                        :value="orderDetail.recipient_phone"
                    ></base-input>
                </div>

				  <div class="col-md-3">
                    <base-input
                        label="วันที่"
                        :value="orderDetail.created_at"
                    ></base-input>
                </div>
            </div>

            <div class="row">
               
                <div class="col-md-6" v-if="orderDetail.discount == 0">
                    <base-input
                        label="ราคา"
                        :value="orderDetail.pay_amount"
                    ></base-input>
                </div>
				 <div class="col-md-3" v-if="orderDetail.discount != 0">
                    <base-input
                        label="ส่วนลด"
                        :value="orderDetail.discount"
                    ></base-input>
                </div> 
				 <div class="col-md-3" v-if="orderDetail.discount != 0">
                    <base-input
                        label="ราคา (หักส่วนลด)"
                        :value="orderDetail.pay_amount"
                    ></base-input>
                </div> 
				
                <div class="col-md-3">
                    <base-input
                        label="ช่องทางการชำระเงิน"
                        :value="orderDetail.payment_method_name"
                    ></base-input>
                </div>
                <div class="col-md-3">
                    <base-input
                        label="พนักงานผู้ตรวจสอบ"
                        :value="orderDetail.bo_payment_user_name"
                    ></base-input>
                </div>
            </div>

			<div class="row" v-if="orderDetail.shipping_cost != 0">
				<div class="col-md-3">
				<base-input
                        label="ค่าจัดส่ง"
                        :value="orderDetail.shipping_cost"
                    ></base-input>
				</div>
			</div>

            <!--  full adress -->
            <div class="row">
                <div class="col-md-8">
                    <base-input
                        label="ที่อยู่"
                        :value="orderDetail.recipient_address_fulladdress + ' ' + orderDetail.recipient_zipcode"
                    ></base-input>
                </div>
                <div class="col-md-4">
                    <base-input
                        label="หมายเหตุ"
                        :value="orderDetail.seller_note"
                    ></base-input>
                </div>
            </div>

			<div class="row" v-if="orderDetail.order_status >= 140">
                <div class="col-md-4">
                    <base-input
                        label="เหตุผลการยกเลิก"
                        :value="GetCancelReasonName(orderDetail.bo_cancel_reason_id)"
                    ></base-input>
                </div>
                <div class="col-md-4">
                    <base-input
                        label="รายละเอียด"
                        :value="orderDetail.cancel_reason"
                    ></base-input>
                </div>
                <div class="col-md-4">
                    <base-input
                        label="ผู้ยกเลิก"
                        :value="orderDetail.bo_cancel_user_name"
                    ></base-input>
                </div>
            </div>

			<div class="row" v-if="orderDetail.order_status >= 140 && orderDetail.bo_cancel_reason_id == 5">
					<label>รูปภาพสินค้าเคลม</label>
				<div class="col-md-12" v-if="orderDetail.images != ''">
					<img v-for="f in orderDetail.images.split(',')" :key="f" :src="GetClaimImage(f)" style="width: 200px; " />
				</div>
			</div>

			<div class="row">
                <div class="col-md-4">
                    <base-input
                        label="ขนส่ง"
                        :value="orderDetail.shipping_provider_name"
                    ></base-input>
                </div>
                <div class="col-md-4" v-if="orderDetail.order_status == 130 || orderDetail.order_status == 121 || orderDetail.order_status == 122">
                    <base-input
                        label="หมายเลขพัสดุ"
                        :value="orderDetail.shipping_tracking_number"
                    ></base-input>
                </div>
                <div class="col-md-4" v-if="orderDetail.order_status == 130 || orderDetail.order_status == 121 || orderDetail.order_status == 122">
                    <base-input
                        label="ผู้จัดส่ง"
                        :value="orderDetail.bo_shipping_user_name"
                    ></base-input>
                </div>

            </div>

			<div class="row">
                <div class="col-md-4">
                    <base-input
                        label="ผู้เปิด Order แพ็ค"
                        :value="orderDetail.packing_opened_user_name"
                    ></base-input>
                </div>
                <div class="col-md-4">
                    <base-input
                        label="เวลาเปิด Order แพ็ค"
                        :value="orderDetail.packing_opened_at"
                    ></base-input>
                </div>
                <div class="col-md-4">
                    <base-input
                        label="เวลาปิด Order แพ็ค"
                        :value="orderDetail.packing_closed_at"
                    ></base-input>
                </div>

            </div>

			<div class="row" v-if="orderDetail.bo_packing_id != 0">
				<div class="col-md-12">
					<base-button class="edit" size="sm" icon @click="handlePackingByID()">
							หมายเลขตัดรอบ : {{ orderDetail.bo_packing_id}}
					</base-button>

					<!-- <base-button class="edit" size="sm" icon @click="handlePrintDocument('A4')">
							พิมพ์ใบปะหน้า : (A4)
					</base-button> -->
					<!-- <base-button class="edit" size="sm" icon @click="handlePrintDocument('100x75')">
							พิมพ์ใบปะหน้า : (100x75)
					</base-button> -->
					<base-button class="edit" size="sm" icon @click="handlePrintDocument('100x150')">
							พิมพ์ใบปะหน้า : (100x150)
					</base-button>
					

				</div>
			</div>


            <hr />
			<div class="row">
				<div class="col-md-12">
					--- สินค้าที่สั่งซื้อ ---
				</div>
			</div>
			<div class="col-md-12" v-if="Detail.order_items == undefined">
				<span > <i class="fas fa-spinner fa-spin"></i>
				กำลังประมวลผล...</span>
			</div>
			<div class="row" v-for="( value) in Detail.order_items" :key="value.id" >
				<div class="col-md-10">
					{{ value.bo_product_name }} : {{ value.bo_product_sku_name  }} 
				</div>
				<div class="col-md-2">x {{ value.quantity }} </div>
			</div>
			<!-- <div class="row">
				<div class="col-md-12">
					--- สินค้าที่ตัดสต๊อก ---
				</div>
			</div>
			<div class="row" v-for="( value) in GetWmsProductSummary()" :key="value.wms_product_id" >
				<div class="col-md-10">
					{{ value.wms_product_name }}  ({{value.barcode }})
				</div>
				<div class="col-md-2">x {{ value.pickup_quantity }} </div>
			</div> -->
            <hr />

			<div class="row" v-if="!IsCod">
				<div class="col-md-6">
					<base-input
                        label="เวลาที่ชำระเงิน"
                        :value="orderDetail.payment_at"
                    ></base-input>

				</div>
			</div>

			<div class="row" v-if="Detail.payment_files != ''">
				<div class="col-md-6">
					<base-input
						label="หลักฐานการชำระเงิน"
					>
					<img :src="DetailImage" style="width: 500px; " v-if="DetailImage != ''"/>
					</base-input>

				</div>
			</div>


            <template slot="footer">
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showDetailModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>


		<modal
            :show.sync="showCancelModal"
            modal-classes="modal-secondary modal-lg"
        >
            <div class="row">
                <div class="col-md-12">
                    <h5 class="modal-title">
                        ยกเลิกรายการสั่งซื้อ : {{ orderDetail.ID }}   ผู้สั่งซื้อ : {{ orderDetail.recipient_name }}
                    </h5>
                </div>
            </div>
			<div class="row">
                <div class="col-md-6">
					<base-input label="ประเภทการยกเลิก">
						<el-select v-model="params_cancel.bo_cancel_reason_id" >
							<el-option
								v-for="option in CancelReasonTable"
								:key="option.ID"
								:label="option.Name"
								:value="option.ID"
							>
							</el-option>
						</el-select>
					</base-input>
                </div>
			</div>
			<div class="row">
                <div class="col-md-8">
					
                    <base-input
                        label="เหตุผลการยกเลิก"
                        v-model="params_cancel.cancel_reason"
                    ></base-input>
                </div>
                <div class="col-md-4" v-if="params_cancel.bo_cancel_reason_id == 5">
                    <base-input
                        label="หมายเลขสั่งซื้อใหม่"
                        v-model="params_cancel.rder_claim_to_id"
                    ></base-input>
                </div>
            </div>

			<div class="row"  v-if="params_cancel.bo_cancel_reason_id == 5">
				<!-- Upload Image -->
				<div class="col-md-12">
					<base-input label="ภาพสินค้า" name="product_claim_image" v-if="params_cancel.images.length < 6">
						<file-input rules="required" @change="claimFilesChange" ></file-input>
					</base-input>

					<img v-for="i in params_cancel.images" :key="i" :src="i" style="width: 200px; " />
				</div>
			</div>

			<template slot="footer">
				<button
                    type="button"
                    class="btn btn-md btn-primary text-white"
                    @click="handelUpdateCancel()"
                >
                    {{ $t("confirm_cancel") }}
                </button>

                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showCancelModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from 'moment'
import FileInput from "@/components/Inputs/FileInput";
import { undistributeHeight } from '@fullcalendar/core';
import { read, utils, writeFile } from 'xlsx'

export default {
    mixins: [clientPaginationMixin],
    components: {
        flatPicker,
		FileInput,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            tableData: "Order/getData",
            UserTable: "User/getData",
            SaleChannelTable: "SaleChannel/getData",
            TeamTable: "Team/getData",
            PaymentMethodTable: "PaymentMethod/getData",
            Detail: "Order/getDatum",
            isLoading: "Order/isLoading",
			PaymentMethodTypeTable:"PaymentMethod/getPaymentMethodTypeTableWithAll",
			setPaymentCurrentPage: "Order/getPaymentCurrentPage",
            getOrderCurrentPage: "Order/getOrderCurrentPage",
			OrderStatusTable: "Order/OrderStatusTableWithAll",
            SaleChannelTableWithAll: "SaleChannel/getDataWithAll",
            SaleChannelTypeTableWithAll: "SaleChannel/getDataTypeWithAll",
			ShippingProviderTable : "Order/getShippingProvider",
			PlatformTable : "Order/getPlatformTable",

			isAdmin : "Auth/isAdmin",
			isOwner : "Auth/isOwner",
			isEmployee : "Auth/isEmployee",
			isAgent : "Auth/isAgent",
			isExpress : "Auth/isExpress",
			isCustomer : "Auth/isCustomer",
			isAccessPayment: "Auth/isAccessPayment"
        }),
		keywordType(){
			let keyword = this.params.order_number

			// check is mobile number , number[10] , start with 0 
			var regIsMobileNumber = /^[0]\d{9}$/g;
			var regIsOrderMdfNumber = /MDF\d{1,12}$/gi;
			var regIsOrderNumber = /^\d{1,12}$/g;
			var regIsThaipost = /^[A-Z]{2}\d{9}[A-Z]{2}$/gi;
			var regIsKerry = /^[A-Z]{4}\d{9}$/gi;
			var regIsKerryLazada = /^[A-Z]{5}\d{10}$/gi;

			console.log("Keyword:",keyword)

			if(regIsMobileNumber.test(keyword)){
				return "เบอร์โทรศัพท์";
			}

			// check is order id  ,  start with mdf , number only
			if(regIsOrderMdfNumber.test(keyword)){
				return "หมายเลขสั่งซื้อ";
			}
			
			if(regIsOrderNumber.test(keyword)){
				return "หมายเลขสั่งซื้อ";
			}

			if(regIsThaipost.test(keyword)){
				return "Tracking : Thaipost";
			}

			if(regIsKerry.test(keyword)){
				return "Tracking : Kerry";
			}

			if(regIsKerryLazada.test(keyword)){
				return "Tracking : Kerry";
			}

			//  check is tracking a-zA-Z  =>     EJ133238776TH   KELB013620312


			return  keyword=="" ? "" : "ชื่อผู้สั่งซื้อ"
		},
		keywordTypeID(){
			let keyword = this.params.order_number

			// check is mobile number , number[10] , start with 0 
			var regIsMobileNumber = /^[0]\d{9}$/g;
			var regIsOrderMdfNumber = /MDF\d{1,12}$/gi;
			var regIsOrderNumber = /^\d{1,12}$/g;
			var regIsThaipost = /^[A-Z]{2}\d{9}[A-Z]{2}$/gi;
			var regIsKerry = /^[A-Z]{4}\d{9}$/gi;
			var regIsKerryLazada = /^[A-Z]{5}\d{10}$/gi;

			console.log("Keyword:",keyword)

			if (this.params.bo_platform_id != 1)
			{
				return 3;
			}

			if(regIsMobileNumber.test(keyword)){
				return 1;
			}

			// check is order id  ,  start with mdf , number only
			if(regIsOrderMdfNumber.test(keyword)){
				return 2;
			}
			
			if(regIsOrderNumber.test(keyword)){
				return 2;
			}

			if(regIsThaipost.test(keyword)){
				return 3;
			}

			if(regIsKerry.test(keyword)){
				return 3;
			}

			if(regIsKerryLazada.test(keyword)){
				return 3;
			}

			//  check is tracking a-zA-Z  =>     EJ133238776TH   KELB013620312


			return  keyword=="" ? 0 : 4
		},
		showForceFilterDate:function(){

			// Disable force filter date
			return false


			// let show = false

			// if (this.isSearchBasic) 
			// 	return show

			// if (this.params.recipient_name != "") {
			// 	show = true
			// }
			// if (this.params.recipient_phone != "") {
			// 	show = true
			// }
			// if (this.params.tracking_number != "") {
			// 	show = true
			// }
			// if (this.params.order_number != "") {
			// 	show = true
			// }
			// return show

		},
		IsCod: function() {
			
			let iscod = false
			let payment_method = this.PaymentMethodTable.filter(v=>{
				return v.id == this.orderDetail.bo_payment_method_id
			})

			if (payment_method.length > 0){
				iscod = payment_method[0].type == 2
			}
			return iscod
		},
        
		CancelReasonTable: function() {
            return [
                { ID: 0, Name: "-- เหตุผลการยกเลิก --" },
                { ID: 1, Name: "ลูกค้าต้องการยกเลิก" },
                { ID: 2, Name: "แอดมินต้องการยกเลิก" },
                { ID: 3, Name: "การขนส่ง" },
                { ID: 4, Name: "การชำระเงิน" },
                { ID: 5, Name: "เคลมสินค้า" },
                { ID: 6, Name: "อื่น ๆ " }
			];
        },
		PackingStatusTable:function(){
			return [
                { id: 0, name: "-- สถานะแพ็ค --" },
                { id: 1, name: "ปิดรายการสั่งซื้อ" },
                { id: 2, name: "ไม่ได้ปิดรายการสั่งซื้อ" },
			]
		},
        OptionUserTable: function() {
            // return UserTable with all
            var data = this.UserTable;
			return [{ UserID: 0, fname: "-- พนักงาน --",lname:"" }, ...data]
            // data.unshift();
            // return data;
        },
        OptionTeamTable: function() {
            // return TeamTable with all
            var data = this.TeamTable;
            return [{ id: 0, name: "-- ทีม --" }, ...data];
        },
		DetailImage:	function(){
			if (this.Detail.payment_files == null || this.Detail.payment_files=="") return "";
			return process.env.VUE_APP_API_BASE_URL + "/files/orders/" + this.Detail.payment_files

		},
		isSearchBasic(){

			return this.searchMode == "basic"

		},
		isSearchAdvance(){
			return this.searchMode == "advance"
		},

		SearchParams : function(){

			let keyword = this.params.order_number
			let filter = 1
			if (this.showForceFilterDate){
				filter = this.params.force_filter_date ? 1:0
			}

			if ( this.params.bo_packing_id != 0  || this.keywordTypeID != 0 ) {
				filter = 0
			} 

			let order_status = []
			switch (this.params.order_status){
				case 0:

				break;

				case 999:
					order_status = [121,122,130]
				break;

				default:
					order_status = [this.params.order_status]
				break;
			}


			if (this.isSearchBasic) {

				return {
					time_from: this.params.time_to,
					time_to: this.params.time_to,
					order_status:order_status ,
					order_number: this.keywordTypeID == 2 ? this.params.order_number.toUpperCase().replace("MDF","") : "",
					tracking_number: this.keywordTypeID == 3 ? keyword : "",
					recipient_name: this.keywordTypeID == 4 ? keyword:"",
					recipient_phone: this.keywordTypeID == 1 ? keyword : "",
					bo_user_id: this.params.bo_user_id,
					bo_team_id: "",
					bo_customer_id: "",
					bo_sale_channel_id: "",
					bo_sale_channel_type_id: 0,
					bo_payment_status: this.params.bo_payment_status,
					bo_packing_id: this.params.bo_packing_id,
					shipping_provider_id: "",
					bo_platform_id: this.params.bo_platform_id,
					payment_method_type: "",
					filter_date: filter,
					packing_not_close:0,
				}

			}
			
			return {
				time_from: this.params.time_from,
                time_to: this.params.time_to,
				order_status:order_status ,
                order_number: this.keywordTypeID == 2 ? this.params.order_number.toUpperCase().replace("MDF","") : "",
				tracking_number: this.keywordTypeID == 3 ? keyword : "",
				recipient_name: this.keywordTypeID == 4 ? keyword:"",
				recipient_phone: this.keywordTypeID == 1 ? keyword : "",
                bo_user_id: this.params.bo_user_id,
                bo_team_id: this.params.bo_team_id,
                bo_payment_method_id: this.params.bo_payment_method_id,
                bo_customer_id: this.params.bo_customer_id,
                bo_sale_channel_id: this.params.bo_sale_channel_id,
                bo_sale_channel_type_id: this.params.bo_sale_channel_type_id,
                bo_payment_status: this.params.bo_payment_status,
                bo_packing_status: this.params.bo_packing_status,
                bo_packing_id: this.params.bo_packing_id,
                shipping_provider_id: this.params.shipping_provider_id,
                bo_platform_id: this.params.bo_platform_id,
				payment_method_type: this.params.payment_method_type,
				filter_date: filter,
				packing_not_close: this.params.packing_not_close,
			}
		},

    },
    data() {
        return {
            propsToSearch: ["OrderNmber", "TrackingNumber"],
            selectedRows: [],
            showAddModal: false,
            showDetailModal: false,
			showCancelModal  : false,
			showChangeTrackingModal : false,
			showChangeShippingModal : false,
			searchMode : "basic", // basic , advance
            params: {
                time_from: "",
                time_to: "",
                order_status: 0,
                order_number: "",
                tracking_number: "",
                recipient_name: "",
                recipient_phone: "",
                bo_user_id: 0,
                bo_team_id: 0,
                bo_payment_method_id: "",
                bo_customer_id: "",
                bo_sale_channel_id: 0,
                bo_sale_channel_type_id: 0,
                bo_payment_status: "",
                bo_packing_status: "",
                bo_packing_id: "",
                shipping_provider_id: "",
                bo_platform_id: 1,
                payment_method_type: 0,
				force_filter_date:true,
				packing_not_close:0,
            },
			params_cancel : {
				bo_cancel_reason_id : 0,
				cancel_reason : "",
				order_claim_to_id : "",
				images:[]
			},
            orderDetail: {
                ID: ""
            },
			// PlatformTable: [
			// 		{id:1,name:"madamefin"},
			// 	{id:2,name:"tiktok"},
			// 	{id:3,name:"shopee"},
			// 	{id:4,name:"lazada"},
			// 	{id:5,name:"line"},
			// ],
			tracking:"",
			shipping_provider_id:1,
			isExportLoading: false,

        };
    },
    async mounted() {

		console.log("param",this.$route.params)
		if (this.$route.params.detail != undefined) {
		console.log("detail",this.$route.params.detail)
			this.handleDetail(this.$route.params.detail)
		}
		// moment today with format YYYY-MM-DD
		this.params.time_from = moment().add(-2, 'days').format('YYYY-MM-DD');
		this.params.time_to = moment().format('YYYY-MM-DD');

		if (this.$route.params.bo_packing_id != undefined) {
			this.params.bo_packing_id = this.$route.params.bo_packing_id;
		}

		if (this.$route.query.platform != undefined) {
			this.params.bo_platform_id = this.GetPlatfromID(this.$route.query.platform)
			this.searchMode = "advance"
		}



		this.listPaymentMethod()
        this.listUser();
        this.listTeam();
		this.listData(this.SearchParams);
        await this.listSaleChannel();

		// if param
    },
    methods: {
        ...mapActions({
            createData: "Order/createData",
            updateData: "Order/updateData",
			cancelData: "Order/cancelData",
			changeTrackingOrder: "Order/changeTrackingOrder",
			changeShippingOrder: "Order/changeShippingOrder",
			checkTrackingOrder: "Order/checkTrackingOrder",
            listData: "Order/listData",
            listDataDetailProduct: "Order/listDataDetailProduct",
            listDatum: "Order/listDatum",
            listUser: "User/listData",
            listOrderDetail: "Order/getData",
            listTeam: "Team/listData",
            listSaleChannel: "SaleChannel/listData",
			listPaymentMethod: "PaymentMethod/listData",
			getShippingDocument: "Packing/getShippingDocument",
			
        }),
		GetPlatfromID(platform) {
			let platform_id = 0
			this.PlatformTable.forEach(v=>{
					console.log(v.name)
				if (v.name.toLowerCase() == platform.toLowerCase())
				{
					platform_id = v.id
				}
			})

			return platform_id == 0 ? 1 : platform_id
		},
		GetClaimImage: function(filename) {
			if (filename == null || filename=="") return "";
			return process.env.VUE_APP_API_BASE_URL + "/files/orders/" + filename
		},
		GetCancelReasonName(id)
		{
			let result = this.CancelReasonTable.find(x => x.ID === id);
			return result != null ? result.Name : "-";
		},
        GetSaleChannelName: function(id) {

            var result = this.SaleChannelTable.find(x => x.id === id);
            return result != null ? result.name : "-";
        },
		GetWmsProductSummary(){
			if (this.orderDetail.wms_product_summary == null) return [];
			let summary = JSON.parse(this.orderDetail.wms_product_summary);
			if (summary != null) {
				return summary;
			} else {
				return [];
			}
		},
        GetOrderStatus(id) {
            var data = this.OrderStatusTable;
            var result = data.find(x => x.ID === id);
            return result != null ? result.Name : "-";
        },
        handleSearch() {
            this.listData(this.SearchParams);
        },
        handleDetail(row) {
            this.showDetailModal = true;
            this.orderDetail = row;
			console.log(this.orderDetail)
            this.listDatum({ id: row.ID });
            //
        },
		handleExport(){

			let i = 1
			let dataExport = this.tableData.map((v) => {
				return {
				NO: i++,
				OrderID: v.ID,
				OrderStatus: this.GetOrderStatus(v.order_status),
				OrderAmount: v.pay_amount,
				OrderDiscount: v.discount,
				PaymentMethod: v.bo_payment_method_name,
				CreatedAt: v.created_at,
				PaymentAt: v.payment_at,
				SaleChannel : this.GetSaleChannelName(v.bo_sale_channel_id),
				Receipent : v.recipient_name,
				RECEIVER_ADDRESS: v.recipient_address_fulladdress,
				RECEIVER_AMPHUR: v.recipient_address_city,
				RECEIVER_PROVINCE: v.recipient_address_province,
				RECEIVER_ZIPCODE: v.recipient_zipcode,
				RECEIVER_TEL: v.recipient_phone,
				Shipping: v.shipping_provider_name,
				Tracking: v.shipping_tracking_number,
				AdminID: v.bo_order_user_id,
				AdminName: v.bo_order_user_name,
				}

			})
			const dataWS = utils.json_to_sheet(dataExport)
			const wb = utils.book_new()
			utils.book_append_sheet(wb, dataWS)
			writeFile(wb,'export_orders.xlsx')
		},
		async handleExportDetail(){

			this.isExportLoading = true
			swal.fire({
				title: this.$t(`processing`),
				type: "info",
				allowEscapeKey: false,
				allowOutsideClick: false,
				onOpen: () => {
					swal.showLoading();
				}
			  });


			let poll = async () => {
				try {
					let i = 1
					let res = await this.listDataDetailProduct(this.SearchParams)
					console.log("res",res)

					if (res.data.Datum.state == 1 ){
						if (res.data.Datum.orders.length == 0){
							swal.fire({
								title: "Export error",
								text: `ไม่พบข้อมูล`,
								icon: "error",
								confirmButtonClass: "btn btn-danger btn-fill",
								buttonsStyling: false
							});
							this.isExportLoading = false
							return
						}
						swal.close()
						this.isExportLoading = false
						console.log("Get response ok",res)
						let dataExport = res.data.Datum.orders.map((v) => {
							return {
							NO: i++,
							OrderID: v.ID,
							OrderStatus: this.GetOrderStatus(v.order_status),
							OrderAmount: v.pay_amount,
							OrderDiscount: v.discount,
							PaymentMethod: v.bo_payment_method_name,
							CreatedAt: v.created_at,
							PaymentAt: v.payment_at,
							SaleChannel : this.GetSaleChannelName(v.bo_sale_channel_id),
							Receipent : v.recipient_name,
							RECEIVER_ADDRESS: v.recipient_address_fulladdress,
							RECEIVER_AMPHUR: v.recipient_address_city,
							RECEIVER_PROVINCE: v.recipient_address_province,
							RECEIVER_ZIPCODE: v.recipient_zipcode,
							RECEIVER_TEL: v.recipient_phone,
							Shipping: v.shipping_provider_name,
							Tracking: v.shipping_tracking_number,
							AdminID: v.bo_order_user_id,
							AdminName: v.bo_order_user_name,
							Product: v.orders_item_product_name,
							SKU: v.orders_item_product_sku_name,
							Quantity : v.orders_item_quantity,
							PricePerUnit: v.orders_item_price_per_unit,
							ProductAmount: (v.orders_item_quantity * v.orders_item_price_per_unit) - v.discount,
							}
						})
						const dataWS = utils.json_to_sheet(dataExport)
						const wb = utils.book_new()
						utils.book_append_sheet(wb, dataWS)
						writeFile(wb,'export_orders_detail.xlsx')
					} else if (res.data.Datum.state == 0){
						console.log("state 0")
						setTimeout(poll, 1000);
					} else {
						this.isExportLoading = false
						swal.fire({
							title: "Export error",
							text: `database failed`,
							icon: "error",
							confirmButtonClass: "btn btn-danger btn-fill",
							buttonsStyling: false
						});
					}
				} catch (err){
					console.log(err)
					this.isExportLoading = false
					swal.fire({
						title: "Export error",
						text: err,
						icon: "error",
						confirmButtonClass: "btn btn-danger btn-fill",
						buttonsStyling: false
					});
				}
			}


			poll();

		},

        handleCreate() {
            this.$router.push("/backoffice/orders/create");
        },
        handleUpdate() {
            // 	this.showAddModal = true;
            //   this.md.ID = 0
            //   this.md.Email = ""
            //   this.md.FName = ""
            //   this.md.LName = ""
            //   this.md.Type = ""
            //   this.md.FbID = ""
            //   this.md.IsBlock = ""
            //   this.md.Tel = ""
            //   this.md.BirthDay = ""
            //   this.md.CreatedAt = ""
            //   this.md.UpdatedAt = ""
        },
        handleEdit(index, row) {
            this.showAddModal = true;

            this.md.ID = row.ID;
            this.md.Email = row.Email;
            this.md.FName = row.FName;
            this.md.LName = row.LName;
            this.md.Type = row.Type;
            this.md.FbID = row.FbID;
            this.md.IsBlock = row.IsBlock;
            this.md.Tel = row.Tel;
            this.md.BirthDay = row.BirthDay;
            this.md.CreatedAt = row.CreatedAt;
            this.md.UpdatedAt = row.UpdatedAt;
        },
        async handleDelete(index, row) {
			this.showCancelModal  = true;
            this.orderDetail = row;
			this.params_cancel.cancel_reason = ""
			this.params_cancel.bo_cancel_reason_id = 0
			this.params_cancel.images = []
        },
		isAccessDeleleteOrder(orderStatus){

			if (this.isAdmin) 
			{
				return true
			} 
			else if (this.isOwner) 
			{
				return true
			} 
			else if (this.isEmployee)
			{
				if (this.isAccessPayment) {
					if (orderStatus != 100 && orderStatus != 111 && orderStatus != 112 ){
						return false
					}
				} else {
					if (orderStatus != 100)
						return false
				}
			} else if (this.isAgent){
				if (orderStatus != 100)
					return false
			}
			

			return true

		},
		handelUpdateCancel(){

			if (this.params_cancel.bo_cancel_reason_id == 0) {
				swal.fire({
					title: this.$t("please_select_cancel_reason"),
					text: ``,
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return;
			}

			if (this.params_cancel.cancel_reason == "") {
				swal.fire({
					title: this.$t("please_input_cancel_reason"),
					text: ``,
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return;
			}

			this.cancelData({
                        id: this.orderDetail.ID,
						payload: this.params_cancel
                    })
                        .then(resp => {
							this.showCancelModal = false;
                            this.listData(this.SearchParams);
                            swal.fire({
                                title: this.$t("cancel_order_success"),
                                text: ``,
                                icon: "success",
                                confirmButtonClass: "btn btn-success btn-fill",
                                buttonsStyling: false
                            });
                        })
                        .catch(err => {
                            swal.fire({
                                title: this.$t(err.response.data.Msg),
                                text: this.getErrorText(err.response.data),
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                        });

		},
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows;
        },
		GetOrderUrl(filename){
			if (filename == null || filename=="") return "";
			return process.env.VUE_APP_API_BASE_URL + "/files/orders/" + filename
		},
		claimFilesChange(files) {

			if (files[0].type != "image/png" && files[0].type != "image/jpeg") {
				swal.fire({
					title: "Error",
					text: "กรุณาเลือกไฟล์รูปภาพ",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
			} 
			
			if (files[0].size > 1024 * 1024 *2 ) {
				swal.fire({
					title: "Error",
					text: "ขนาดไฟล์รูปภาพต้องไม่เกิน 2 MB",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return;
			}

			const reader = new FileReader();
            reader.readAsDataURL(files[0]);
            reader.onload = () => {
				// append to params cancel image array
				this.params_cancel.images.push(reader.result)
            };
        },
		handleChangeShipping(row){
			this.showChangeShippingModal = true
			this.orderDetail = row
			this.shipping_provider_id = row.shipping_provider_id
		},
		handleUpdateShipping(){
			this.changeShippingOrder({
                        id: this.orderDetail.ID,
						payload: {
							shipping_provider_id: this.shipping_provider_id
						}
                    }).then(resp => {
							this.showChangeShippingModal = false;
                            this.listData(this.SearchParams);
                            swal.fire({
                                title: this.$t("change_shipping_success"),
                                text: ``,
                                icon: "success",
                                confirmButtonClass: "btn btn-success btn-fill",
                                buttonsStyling: false
                            });
                        })
                        .catch(err => {
							this.showChangeTrackingModal = false
                            swal.fire({
                                title: this.$t(err.response.data.Msg),
                                text: this.getErrorText(err.response.data),
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                        });

		},
		handleChangeTracking(row){
			this.showChangeTrackingModal = true
			this.orderDetail = row
			this.tracking = row.shipping_tracking_number

		},

		handleUpdateTracking(){
			this.changeTrackingOrder({
                        id: this.orderDetail.ID,
						payload: {
							tracking_number: this.tracking
						}
                    })
                        .then(resp => {
							this.showChangeTrackingModal = false;
                            this.listData(this.SearchParams);
                            swal.fire({
                                title: this.$t("change_tracking_success"),
                                text: ``,
                                icon: "success",
                                confirmButtonClass: "btn btn-success btn-fill",
                                buttonsStyling: false
                            });
                        })
                        .catch(err => {
							this.showChangeTrackingModal = false
                            swal.fire({
                                title: this.$t(err.response.data.Msg),
                                text: this.getErrorText(err.response.data),
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                        });

		},
		handlePackingByID(){
			this.$router.push({name : "BOPacking", params : { bo_packing_id : this.orderDetail.bo_packing_id} })
		},
		async handlePrintDocument(pagesize){
			this.getShippingDocument({order_id:this.orderDetail.ID,pageSize:pagesize}).then(resp => {
				// url = api path 
				let url = process.env.VUE_APP_API_BASE_URL + "/files/packings/" + resp.data.Datum.url
				window.open(url, '_blank');
			}).catch(err => {
				swal.fire({
					title: err.response.data.Cause,
					text: "",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
			});
		},
		async handleCheckTracking(providerId,trackingNumber){


			if (providerId == 1 ) {
				let url = "https://track.thailandpost.co.th/?trackNumber=" + trackingNumber
				try {
					await navigator.clipboard.writeText(url)
				} catch (err){
					console.log(err)
				}
				// window.open(url)
			} else if (providerId == 2 ) {
				let url = "https://th.kerryexpress.com/th/track/"
				try {
					await navigator.clipboard.writeText(url)
				} catch (err){
					console.log(err)
				}
				// window.open(url)

			}

		}
    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
